<template>

	<div class="gray-bg" style="min-height: 100vh">
    
    <div class="middle-box text-center animated fadeInDown">
      <!-- <h1>500</h1> -->
      <h3 class="font-bold">Logging out...</h3>
    </div>

  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageLogout",
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }

    let config = helper.createAxiosConfig();
    config['timeout'] = 10000;

    this.$http
      .get(
        helper.API_URL + '/api2/auth/logout', 
        config
      )
      .finally(() => {
        localStorage.removeItem('user');
        localStorage.removeItem('meRoles');
        localStorage.removeItem('selectedRoleID');
        localStorage.removeItem('selectedCustomerID');
        localStorage.removeItem('selectedOperatorID');
        localStorage.removeItem('salt');
        helper.redirect(helper.WEB_URL + '/login');
      });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageLogout.vue